export * from "./card-data";
export * from "./ui-toggles";
export * from "./sort-by";
export * from "./filter";
export * from "./placeholders";
import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { RiftboundCardSchema, RiftboundSetSchema } from "./card-data";
import { AsyncConfigSchema, BackdropSchema, BladeHeaderSchema } from "../../fragments";
import { SortBySchema } from "./sort-by";
import { FilterSchema } from "./filter";
import { UIToggleListSchema } from "./ui-toggles";
import { RiftboundPlaceholdersSchema } from "./placeholders";
const RiftboundCardGalleryBladeTypeValues = ["riftboundCardGallery"];
export const RiftboundCardGalleryBladeTypesSchema = z.enum(RiftboundCardGalleryBladeTypeValues);
export const RiftboundCardGalleryBladeTypes = RiftboundCardGalleryBladeTypesSchema.enum;
export const RiftboundCardGalleryBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    sets: z.object({
        items: z.array(RiftboundSetSchema),
        async: AsyncConfigSchema.optional(),
    }),
    cards: z.object({
        items: z.array(RiftboundCardSchema),
        async: AsyncConfigSchema.optional(),
    }),
    placeholders: RiftboundPlaceholdersSchema.optional(),
    sortBy: SortBySchema.optional(),
    filters: FilterSchema.optional(),
    uiToggles: UIToggleListSchema.optional(),
});
export const RiftboundCardGalleryBladesContractSchema = RiftboundCardGalleryBladeSchema.extend({
    type: RiftboundCardGalleryBladeTypesSchema,
});
export const RiftboundCardGalleryContractSchema = RiftboundCardGalleryBladesContractSchema.extend({
    type: z.literal(RiftboundCardGalleryBladeTypes.riftboundCardGallery),
});
//# sourceMappingURL=index.js.map